module.exports = __webpack_public_path__ + "img/water.91b18010.svg";